module.exports = __webpack_public_path__ + "static/media/bz.26d8c855.png";